// Single source for PULSE legal document versions. Set status "final" and an effectiveDate only after owner + legal approval.
// Before publication, terms.version must match the Terms version configured in the PULSE app (currently "unpublished-draft").
export const LEGAL_DOCS = {
  privacy: { version: "0.4", status: "draft", lastUpdated: "October 2026", effectiveDate: null, archive: [] },
  terms: { version: "0.4", status: "draft", lastUpdated: "October 2026", effectiveDate: null, appTermsVersion: "unpublished-draft", archive: [] },
  deleteAccount: { version: "0.4", status: "draft", lastUpdated: "October 2026", effectiveDate: null, archive: [] },
};

const PRODUCTION_HOSTS = ["veyronix.co.uk", "www.veyronix.co.uk"];

// Internal review notes: never in production builds; only in the development server with ?review=1, or when rendering internal Markdown.
export const showReviewNotes = () => {
  if (globalThis.PULSE_REVIEW_NOTES === true) return true;
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("review") === "1" && !PRODUCTION_HOSTS.includes(window.location.hostname);
};
